<!-- 由 suu 创建于 2025-07-07 星期一 -->
<template>
  <van-overlay :show="true" z-index="1000" :lock-scroll="false">
    <div class="sscp-wrap">
      <div class="sscp-title"> 停卡权益说明 </div>
      <div class="sscp-content">
        <div class="sscp-sub">
          亲爱的健萌er
          <br />感谢您选择健萌！为了让您更安心地享受服务，我们特别说明关于<span
            class="content-red"
            >健康原因停卡</span
          >的温馨约定：
        </div>
        <div class="sscp-content-list">
          <div class="list-title"> 如因身体原因需暂停训练，您可： </div>
          <div class="list-item" v-for="(item, index) in reason" :key="index">
            <van-icon class="list-item-icon" name="passed" />
            <div class="list-item-text">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="sscp-content-list">
          <div class="list-title"> 我们承诺： </div>
          <div
            class="list-item"
            v-for="(item, index) in commitment"
            :key="index"
          >
            <div class="list-item-dot"></div>
            <div class="list-item-text">
              {{ item }}
            </div>
          </div>
        </div>
        <div class="sscp-tips"> 如有任何疑问，可联系您的教练或门店店长。</div>
      </div>
      <div
        class="sscp-btn user-btn"
        :class="{ 'sscp-btn-off': countdown }"
        @click="handleAccept"
        >我已阅读并接受{{ countdown ? `（${countdown}s）` : '' }}</div
      >
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'special-stop-card-pop',

  components: {},

  props: {},

  data() {
    return {
      countdown: 5,
      timer: null,
      // 原因
      reason: [
        '提供正规医疗机构开具的书面医嘱（如：门诊病历、体检报告等）',
        '申请停卡，单次最长30天（会员有效期将自动顺延）',
        '教练根据您的身体状态调整后续训练计划'
      ],
      // 承诺
      commitment: [
        '您的医疗材料仅用于停卡审核及训练计划调整',
        '审核专员处理，保护会员隐私',
        '仅需保留医嘱单据的必要信息（医院/姓名/日期/诊断结果）'
      ]
    }
  },

  computed: {},

  watch: {},

  created() {
    this.init()
  },

  mounted() {},

  destroyed() {},

  methods: {
    init() {
      this.countdown = 5
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.countdown = 0
        }
      }, 1000)
    },
    handleAccept() {
      if (this.countdown > 0) {
        return
      }
      this.$emit('on-close')
      this.$http.get('member/index?a=addCardSuspensionRightsLog', {})
      this.$http.get('member/index?a=shareLogPush', {
        from: `医嘱停卡权益说明弹窗-点击确认`,
        from_id: 25070888
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.sscp-wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);
  width: vw(295);
  box-sizing: border-box;
  background: #fff;
  border-radius: vw(12);
  padding-bottom: vw(20);
  padding-top: vw(16);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  .sscp-title {
    font-weight: 600;
    font-size: vw(20);
    color: #000000;
    line-height: vw(26);
  }
  .sscp-content {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: vw(14);
    overflow-y: auto;
    height: vw(255);
    .sscp-sub {
      width: 100%;
      box-sizing: border-box;
      padding: 0 vw(20);
      font-weight: 500;
      font-size: vw(13);
      color: #000000;
      line-height: vw(20);
      .content-red {
        color: #dc0050;
      }
    }
    .sscp-content-list {
      width: 100%;
      box-sizing: border-box;
      padding-left: vw(20);
      padding-right: vw(22);
      font-weight: 400;
      font-size: vw(13);
      color: #000000;
      line-height: vw(20);
      margin-top: vw(12);
      .list-title {
      }
      .list-item {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        .list-item-icon {
          font-size: vw(11);
          // color: rgba($color: #000000, $alpha: 0.8);
          margin-right: vw(7);
          margin-top: vw(3);
        }
        .list-item-text {
          flex: 1;
        }
        .list-item-dot {
          width: vw(5);
          height: vw(5);
          margin-top: vw(6);
          background: #000000;
          border-radius: 50%;
          margin-right: vw(9);
        }
      }
    }
    .sscp-tips {
      width: 100%;
      box-sizing: border-box;
      padding-left: vw(20);
      font-weight: 400;
      font-size: vw(13);
      color: #000000;
      line-height: vw(20);
      margin-top: vw(12);
    }
  }
  .sscp-btn {
    width: vw(255);
    box-sizing: border-box;
    height: vw(44);
    background: #dc0050;
    border-radius: vw(22);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: vw(18);
    color: #ffffff;
    margin-top: vw(16);
    &.sscp-btn-off {
      opacity: 0.3;
    }
  }
}
</style>
